<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <router-link :to="{name: 'App', params: { id: 'new' }}"><button type="button" class="btn btn-primary"><i class="fa fa-plus"></i> New App</button></router-link>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Apps
          </div>
          <div class="card-block">
            <table class="table table-bordered table-striped table-condensed">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Branding</th>
                  <th>UID</th>
                  <th>Platform</th>
                </tr>
              </thead>
              <tbody>
                <loading-rows v-if="loading" cols='4'/>
                <tr v-for="app in apps" v-if="!loading">
                  <td><router-link :to="{ name: 'App', params: {id: app.id} }">{{app.name}}</router-link></td>
                  <td>{{app.branding}}</td>
                  <td>{{app.uid}}</td>
                  <td>{{app.platform}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div><!--/.col-->
    </div><!--/.row-->
  </div>

</template>

<script>

import apps from 'services/apps'
import LoadingRows from 'components/LoadingRows'

export default {
  name: 'apps',
  data () {
    return {
      apps: [],
      loading: false
    }
  },
  created () {
    apps.all(this)
  },
  components: {
    LoadingRows
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apps/Apps.vue